import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

const state = {
    isShowloading: false
}
const mutations={
    showLoading(state){
        state.isShowloading = true;
    },
    hideLoading(state){
        state.isShowloading = false;
    }
}
export default new Vuex.Store({
    state,
    mutations
})


// WEBPACK FOOTER //
// ./src/vuex/store.js